import { formatPrice } from "@/lib/utils/price";


type PriceType =  | number
| (
    | {
        priceListId?: string | undefined;
        price?: number | null | undefined;
      }
    | undefined
  )[]
| null
| undefined;


interface IPriceProps {
  price?: PriceType;
  priceBeforeDiscount?: PriceType;
}

const Price = ({ price, priceBeforeDiscount }: IPriceProps) => {
  if (!price) return null;


  const priceAsNumber = typeof price === "number" ? price : price?.[0]?.price;
  const formattedPrice = formatPrice(priceAsNumber);

  const priceBeforeDiscountAsNumber = typeof priceBeforeDiscount === "number" ? priceBeforeDiscount : priceBeforeDiscount?.[0]?.price;
  const priceBeforeDiscountFormatted = formatPrice(priceBeforeDiscountAsNumber);

  const isOnSale = Boolean(priceAsNumber) && Boolean(priceBeforeDiscountAsNumber) && priceAsNumber! < priceBeforeDiscountAsNumber!;

  return <strong data-layout="price">{formattedPrice} {isOnSale && <span>{priceBeforeDiscountFormatted}</span>}</strong>;
};

export default Price;
